import * as QuizTypes from './quizTypes';

export const addQuizWithReplies = (formation_id, quiz_id, answers_list) => ({
    type: QuizTypes.ADD_QUIZ_WITH_REPLIES,
    payload: { quiz: { id: quiz_id, formation_id, answers_list } },
});

export const removeFormationQuizzes = (formation_id) => ({
    type: QuizTypes.REMOVE_FORMATION_QUIZZES,
    payload: { formation_id },
});

export const clearState = () => ({ type: QuizTypes.CLEAR_STATE });
